import { CardGroup, Card, Icon } from '@ver-uds/uswds-react';
import { Button } from '@ver-uds/react';
import React from 'react';
import './LatestNewsCard.scss';
import ExternalLinks from '../../constants/ExternalLinks';

interface Props {
  addTopMargin?: boolean;
}

const LatestNewsCard = ({ addTopMargin }: Props): JSX.Element => {
  return (
    <CardGroup className={`latest-news-card-group${addTopMargin ? ' margin-top-5' : ''}`}>
      <Card flag className="latest-news-card">
        <Card.Header as="h3">
          Find the Latest News on <span className="nobr">E-Verify</span>.gov
        </Card.Header>
        <Card.Body>
          <p>
            We are working to bring exciting new functionality to <span className="nobr">E-Verify</span>. While we are
            building these new tools, you can find the latest news updates on <span className="nobr">E-Verify</span>
            .gov.
          </p>
        </Card.Body>
        <Card.Footer>
          <Button
            iconRight={<Icon name="launch" />}
            onClick={() => window.open(`${ExternalLinks.E_VERIFY}/about-e-verify/whats-new`, '_blank')}
            aria-label="Click here to open the What's New page in a new tab"
          >
            View Latest
          </Button>
        </Card.Footer>
      </Card>
    </CardGroup>
  );
};

LatestNewsCard.defaultProps = { addTopMargin: false };

export default LatestNewsCard;
